import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useBootAuth } from './hooks/useAuth';
import { ToastContainer } from './components/ui/Toast';
import Router from './router';
import { hideSplash } from './components/brand/splash';
import { useAuthStore } from './stores/auth.store';

function AppInner() {
  useBootAuth();
  const authLoading = useAuthStore(s => s.isLoading);
  useEffect(() => {
    if (!authLoading) hideSplash();
  }, [authLoading]);

  return (
    <>
      <Router />
      <ToastContainer />
    </>
  );
}

function SentryErrorFallback() {
  useEffect(hideSplash, []);
  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4 text-center px-6">
      <p className="text-lg font-semibold text-slate-800 dark:text-slate-100">Something went wrong</p>
      <p className="text-sm text-slate-500">The error has been reported. Please refresh the page.</p>
      <button onClick={() => window.location.reload()} className="btn-primary">Refresh</button>
    </div>
  );
}

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={<SentryErrorFallback />}>
      <BrowserRouter>
        <AppInner />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}
